<template>
<div>
    <h1 class='h-text-center h-mt-50'>
        {{ $t('AUTH.CREATE_PASSWORD.HEADER') }}
    </h1>
    <div class='b-page-wrapper b-page-wrapper--gray h-flex h-flex-center'>
        <FwPopup
            :centered='true'
            :isFixed='true'
            :max-width='isDesktop() ? "420px" : "calc(100% - 20px)"'
            width='90%'
            popupClass='b-popup-style--no-shadow'
            :allowBackgroundScrolling='true'
            :disableClosingOnClickOutside='true'
            popupBackground='#fff'
            popupRadius='20px'>
            <template #body>
                <div class='h-flex h-flex-space-between h-flex-dir-column'>
                    <div class='h-text-center h-mb-20'>
                        <div class='b-base-title h-mt-10'>
                            {{ $t('AUTH.CREATE_PASSWORD.TITLE') }}
                        </div>
                    </div>
                    <div>
                        <FwFormInput
                            class='h-mb-25'
                            :fieldHasError='fieldHasErrorByRule(password, PASSWORD, passwordRules)'
                            labelType='label-thin'
                            :title='$t(`AUTH.LOGIN.FORM.PASSWORD.LABEL`)'>
                            <FwInput
                                :value='password'
                                type='password'
                                name='password'
                                :placeholder='$t(`AUTH.LOGIN.FORM.PASSWORD.PLACEHOLDER`)'
                                inputStyle='gray'
                                :error='getFieldErrorTextByRule(password, PASSWORD, passwordRules)'
                                @update='value => password = value'
                                @input='clearServerErrorsBase(PASSWORD)'
                                @blur='addCurrentInputToValidateArray(PASSWORD)'>
                            </FwInput>
                        </FwFormInput>
                    </div>
                    <div class='b-create-password-approve h-flex'>
                        <FwCheckbox
                            v-model='approve_tcs'
                            :disabled='false'
                            name='checkbox'>
                            <div class='b-create-password-approve-text'>
                                {{ $t('AUTH.CREATE_PASSWORD.TCS_APPROVE.TEXT') }}
                                <span class='b-create-password-approve-link'>
                                    {{ $t('AUTH.CREATE_PASSWORD.TCS_APPROVE.LINK_TEXT') }}
                                </span>
                            </div>
                        </FwCheckbox>
                    </div>

                    <div class='h-flex h-flex-center h-width-100p'>
                        <FwButton
                            class='h-mt-30'
                            :disabled='!isFormValid'
                            borderRadiusType='small-border'
                            @click='sendDataToServer'>
                            {{ $t('AUTH.CREATE_PASSWORD.BUTTON') }}
                        </FwButton>
                    </div>
                </div>
            </template>
        </FwPopup>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, mixins } from 'vue-facing-decorator';
import { PASSWORD, APPROVE_TCS } from '@/helpers/auth';
import { AuthWebApi } from '@/api/auth/AuthApi';
import { useValidation } from '@/composables/useValidation';
import AuthMixin from '@/mixins/auth';
import { ServerErrorsType } from '@/types/Validation';
import { useGlobalStore } from '@/stores/useGlobalStore';

@Component
export default class CreatePasswordPage extends mixins(AuthMixin) {
    globalStore = useGlobalStore();
    [PASSWORD]: string = '';
    [APPROVE_TCS]: boolean = false;
    PASSWORD: string = PASSWORD;
    APPROVE_TCS: string = APPROVE_TCS;
    passwordRules: string[] = ['required', 'passwordMin'];

    validation = useValidation();

    get fieldHasErrorByRule() {
        return this.validation.fieldHasErrorByRule;
    }

    get getFieldErrorTextByRule() {
        return this.validation.getFieldErrorTextByRule;
    }

    get clearServerErrorsBase() {
        return this.validation.clearServerErrorsBase;
    }

    get addCurrentInputToValidateArray() {
        return this.validation.addCurrentInputToValidateArray;
    }

    get isFormValid() {
        return this.validation.passwordValidator({ value: this[PASSWORD] }) &&
            Boolean(this[APPROVE_TCS]);
    }

    async sendDataToServer() {
        const payload = { email: this.user.email, password: this[PASSWORD] };
        const { data } = await AuthWebApi.confirmPassword(payload);
        this.user.active = true;
        this.globalStore.mutationLoginUser(this.user);
        this.$router.push({ path: '/onboarding/welcome' });
    }
}
</script>

<style lang='sass'>
.b-create-password-approve
    margin-top: 10px
    margin-bottom: 10px

    &-text
        font-size: 16px
        line-height: 16px
        font-weight: bold

    &-link
        text-decoration: underline
</style>
